import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["audience", "admission", "errors"]
  static values = { open: Boolean, returnFocus: String }

  connect() {
    this.updateAdmission()
    if (this.openValue) {
      this.element.addEventListener("shown.bs.modal", () => {
        if (this.hasErrorsTarget) this.errorsTarget.focus()
      }, { once: true })
      Modal.getOrCreateInstance(this.element).show()
    }
  }

  updateAdmission() {
    if (!this.hasAudienceTarget) return

    const manualOnly = this.audienceTarget.value === "anyone"
    this.admissionTarget.querySelector("option[value='automatic']").disabled = manualOnly
    if (manualOnly) this.admissionTarget.value = "manual"
  }

  restoreFocus() {
    if (this.hasReturnFocusValue) document.getElementById(this.returnFocusValue)?.focus()
  }

  cleanup() {
    const modal = Modal.getInstance(this.element)
    if (modal) {
      modal.hide()
      modal.dispose()
    }
    this.element.classList.remove("show")
    this.element.style.display = "none"
    this.openValue = false
  }

  disconnect() {
    this.cleanup()
  }
}
